const feedbackUtil = {
    DOM: {
        fileChooser: null,
    },
    makePreviewFromDataURL(dataURL){
        let image = document.createElement('img');
        image.style.maxWidth = '100%';
        image.src = dataURL;

        document.getElementById('feedback-screenshot').value = dataURL;

        let previewWrapper = document.querySelector('#feedbackModalContent .screenshot-preview');
        previewWrapper.innerHTML = '';
        previewWrapper.append(image);
    },
    takePhotoReal(track){
        let imageCapture = new ImageCapture(track);

        imageCapture.grabFrame().then(function (imgBitmap) {

            //let canvas = document.getElementById('mycanvas');
            let canvas = document.createElement('canvas');


            canvas.width = imgBitmap.width;
            canvas.height = imgBitmap.height;
            canvas.getContext('2d').drawImage(imgBitmap, 0, 0);
            let dataURL = canvas.toDataURL();

            feedbackUtil.makePreviewFromDataURL(dataURL);

            track.stop();

            feedbackUtil.toggleScreenBar(2);
            $("#feedbackModal").modal('show');
        });
    },

    takePhoto(track){

        window.setTimeout(function () {
            feedbackUtil.takePhotoReal(track);
        }, 1000)

    },
    mediaStreamReceived(mediaStream){
        //console.log("Received local stream", mediaStream);

        const track = mediaStream.getVideoTracks()[0];

        feedbackUtil.takePhoto(track)
    },

    screenshot(){
        $("#feedbackModal").modal('hide');

        navigator.mediaDevices.getDisplayMedia({
            audio:false,
            video: { mandatory: {
                    maxWidth: 4000,
                    maxHeight: 4000} }
        })
            .then(feedbackUtil.mediaStreamReceived)
            .catch(err => { $("#feedbackModal").modal('show');
                console.error("Error:" + err); return null; })

    },
    noscreenshot()
    {
        document.querySelector('#feedbackModalContent .screenshot-preview').innerHTML = '';
        document.getElementById('feedback-screenshot').value = '';
        this.DOM.fileChooser.value = '';
        feedbackUtil.toggleScreenBar(1);
    },
    toggleScreenBar(barNum){
        $("#feedback-screen-bar-1").toggleClass('d-none', barNum !== 1);
        $("#feedback-screen-bar-2").toggleClass('d-none', barNum === 1);
    },
    handleFileSelect(event){
        // Get the FileList object from the file select event
        const files = event.target.files;

        // Check if there are files in the FileList
        if(files.length === 0)
        {
            return;
        }

        // For this example we only want one image. We'll take the first.
        const file = files[0];

        // Check that the file is an image
        if(file.type !== '' && !file.type.match('image.*'))
        {
            return;
        }

        const reader = new FileReader();
        reader.onload = function(e) {
            let dataURL = e.target.result;

            feedbackUtil.makePreviewFromDataURL(dataURL);

            feedbackUtil.toggleScreenBar(2);

        };
        reader.readAsDataURL(file);
    },
    init(){
        this.DOM.fileChooser = document.querySelector('#customScreenshotFile');

        if(! this.DOM.fileChooser) {
            return;
        }

        this.DOM.fileChooser.addEventListener('change', feedbackUtil.handleFileSelect, false);

        if(! navigator.mediaDevices || typeof ImageCapture === 'undefined'){
            document.getElementById('feedb-screenshot-btn-wrap').classList.add('d-none')
        }
    }
};

feedbackUtil.init();

window.feedbackUtil = feedbackUtil;

export { feedbackUtil };
